import { ProAndCons } from '../../../types/car-review-page'
export interface ProsAndConsArray {
  title: 'Pros' | 'Cons'
  body: string[]
}

export function createProsAndConsArray(
  prosList: ProAndCons[],
  consList: ProAndCons[],
): ProsAndConsArray[] {
  const pros: ProsAndConsArray = {
    title: 'Pros',
    body: prosList.map((item) => item.text),
  }

  const cons: ProsAndConsArray = {
    title: 'Cons',
    body: consList.map((item) => item.text),
  }

  return [pros, cons]
}
